<template>
  <div class="drawerWrap devDetailDW">
    <div class="drawerBody detailsDrawerBody">
      <div class="basic detailsItem">
        <h4>基本信息</h4>
        <div class="details">
          <ul>
            <li>
              <div class="label">设备名称:</div>
              <div class="value">{{ datailsData.name }}</div>
            </li>
            <li>
              <div class="label">IMEI:</div>
              <div class="value">{{ datailsData.imei }}</div>
            </li>
            <li>
              <div class="label">是否注册:</div>
              <div class="value">{{ datailsData.isRegist }}</div>
            </li>
            <!-- <li v-if="datailsData.isRegist == '已注册'">
              <div class="label">设备注册至:</div>
              <div class="value">{{ datailsData.registType }}</div>
            </li> -->
            <li>
              <div class="label">是否安装:</div>
              <div class="value">{{ datailsData.isInstall }}</div>
            </li>
            <li>
              <div class="label">是否报警:</div>
              <div class="value">{{ datailsData.isAlarm }}</div>
            </li>
            <li>
              <div class="label">是否故障:</div>
              <div class="value">{{ datailsData.isFault }}</div>
            </li>
            <li>
              <div class="label">是否启用:</div>
              <div class="value">{{ datailsData.isEnabled }}</div>
            </li>
            <li>
              <div class="label">是否在线:</div>
              <div class="value">{{ datailsData.isOnline }}</div>
            </li>
            <li>
              <div class="label">通知人员类型:</div>
              <div class="value">
                {{
                  datailsData.noticeUserType == 1 ? '通知负责人' : datailsData.noticeUserType == 2 ? '通知安装人' : '通知安装人和负责人'
                }}
              </div>
            </li>

            <li>
              <div class="label">通信协议方式:</div>
              <div class="value">{{ datailsData.protocol==0 ? 'MQTT' : (datailsData.protocol==1 ? "NB" :(datailsData.protocol==2 ? "HTTP" :(datailsData.protocol==3 ? "TCP" : '未知'))) }}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装位置:</div>
              <div class="value">{{ datailsData.installLocation }}</div>
            </li>
            <li v-if="datailsData.isInstall  == '已安装'">
              <div class="label">安装时间:</div>
              <div class="value">{{ datailsData.installTime }}</div>
            </li>
            <!-- <li>
              <div class="label">使用者:</div>
              <div class="value">{{ datailsData.user }}</div>
            </li>
            <li>
              <div class="label">使用者联系方式:</div>
              <div class="value">{{ datailsData.userTel }}</div>
            </li> -->
            <li>
              <div class="label">安装区域</div>
              <div class="value" v-if="datailsData.region">{{ datailsData.region.name }}</div>
            </li>
            <li>
              <div class="label">负责人、联系方式:</div>
              <div class="value" v-if="datailsData.region">
                <div v-for="(item,index) in datailsData.region.chargePersonList" :key="index" style="lineHeight:24px;">
                  <span>{{item.nickName}}</span><span>（{{item.tel}}）</span>
                </div>
              </div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装人员:</div>
              <div class="value">{{ datailsData.installUser }}</div>
            </li>
            <li v-if=" datailsData.isInstall == '已安装' ">
              <div class="label">安装人员联系方式:</div>
              <div class="value">{{ datailsData.installUserTel }}</div>
            </li>
            <li>
              <div class="label">入库时间:</div>
              <div class="value">{{ datailsData.createTime }}</div>
            </li>
            <li>
              <div class="label">信号值:</div>
              <div class="value">{{ datailsData.signal }}</div>
            </li>
            <li>
              <div class="label">迁移值B:</div>
              <div class="value">{{ datailsData.migrateB }}</div>
            </li>
            <li>
              <div class="label">迁移值K:</div>
              <div class="value">{{ datailsData.migrateK }}</div>
            </li>
            <li>
              <div class="label">厂商编号:</div>
              <div class="value">{{ datailsData.manufacturer }}</div>
            </li>
            <li>
              <div class="label">采集间隔:</div>
              <div class="value">{{ datailsData.scanA }}</div>
            </li>
            <li>
              <div class="label">发送间隔:</div>
              <div class="value">{{ datailsData.sendingE }}</div>
            </li>
            <li>
              <div class="label">波动值警告:</div>
              <div class="value">{{ datailsData.wave }}</div>
            </li>
            <li>
              <div class="label">阈值上限:</div>
              <div class="value">{{ datailsData.thresholdHig }}</div>
            </li>
            <li>
              <div class="label">阈值下限:</div>
              <div class="value">{{ datailsData.thresholdLower }}</div>
            </li>
            <li>
              <div class="label">创建时间:</div>
              <div class="value">{{ datailsData.createTime }}</div>
            </li>
            <li>
              <div class="label">更新时间:</div>
              <div class="value">{{ datailsData.updateTime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datailsData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  watch: {
    datailsData(newV) {
      console.log(newV);

    }
  },
  created() {
    console.log(this.datailsData)

  },
  mounted() {

  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.detailsDrawerBody {
  padding: 10px 35px;

  .detailsItem {
    padding-left: 20px;

    h4 {
      font-size: 16px;
      color: #333;
      line-height: 38px;
      font-weight: bold;
      border-bottom: 1px solid #aaa;
    }

    .details {
      padding: 10px 0;

      ul {

        li {
          line-height: 38px;

          .label {
            display: inline-block;
            vertical-align: middle;
            color: #bbb;
            width: 150px;
          }

          .value {
            display: inline-block;
            vertical-align: middle;
            color: #888;
            margin-left: 5px;

            .unit {
              margin-left: 10px;
            }
          }
        }
      }

      .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -20px;
      }
    }

    &.params {
      .details {
        padding-right: 100px;
        position: relative;
      }
    }

  }

}
</style>
